import React from 'react';
import { useTranslation } from "react-i18next";
import { BsX } from 'react-icons/bs';

const OffAirLive = ({ selectedLiveInfo, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    return (
        <div className="hc-unified-alert-card hc-live-alert-card" onClick={handlePreventClick}>
            <div className="hc-unified-alert-header">
                <span className="hc-unified-alert-kicker">ON AIR</span>
                <button type="button" className="hc-unified-alert-close" onClick={() => handleSelectedFunc({ selectedFunc: "OFFAIR_TOGGLE", liveSeq:-1 })} aria-label="닫기">
                    <BsX />
                </button>
            </div>
            <div className="hc-unified-alert-title">
                <span>{t("클래스_방송_종료_문구_1", { ns: "live" })}</span>
                <span>{t("클래스_방송_종료_문구_2", { ns: "live" })}</span>
            </div>
            <div className="hc-unified-alert-details">
                <div className="hc-unified-alert-detail-row">
                    <span className="hc-unified-alert-label">{t("클래스_이름", { ns: "live" })}</span>
                    <span className="hc-unified-alert-value" title={selectedLiveInfo.liveName}>
                        {selectedLiveInfo.liveName}
                    </span>
                </div>
            </div>
            <div className="hc-unified-alert-actions">
                <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-danger" onClick={() => handleSelectedFunc({ selectedFunc: "OFFAIR", liveSeq: selectedLiveInfo.liveSeq, liveName:selectedLiveInfo.liveName })}>{t("예", { ns: "common" })}</button>
                <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-secondary" onClick={() => handleSelectedFunc({ selectedFunc: "OFFAIR_TOGGLE", liveSeq: -1 })}>{t("아니오", { ns: "common" })}</button>
            </div>
        </div>
    );
}

export default OffAirLive;
